export default __webpack_public_path__ + "static/media/beats-headphone.6017345d.png";